import { useState, useRef, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Bell, Moon, Sun, ChevronDown, PlusCircle, ListOrdered } from 'lucide-react';

export default function Header({ darkMode, setDarkMode, showMobileSidebar }) {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);

  // Close dropdown when clicking outside
  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownOpen(false);
      }
    }

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <header
      className={`bg-white dark:bg-gray-800 shadow-md border-b border-gray-200 dark:border-gray-700 h-16 flex items-center justify-between px-4 transition-all duration-300 ps-[55px] md:ps-4`}
    >
      <div className="flex items-center space-x-3">
        <span className="text-lg font-semibold text-gray-700 dark:text-white">Dashboard</span>
        <div className="flex items-center space-x-2">
          <Link
            to="/orders/create"
            className="flex items-center space-x-1 px-2 py-1 text-sm bg-indigo-600 text-white rounded hover:bg-indigo-500"
          >
            <PlusCircle size={16} />
            <span className="hidden sm:inline">Create Order</span>
          </Link>
          <Link
            to="/orders"
            className="flex items-center space-x-1 px-2 py-1 text-sm bg-gray-200 text-gray-800 rounded hover:bg-gray-300 dark:bg-gray-700 dark:text-white dark:hover:bg-gray-600"
          >
            <ListOrdered size={16} />
            <span className="hidden sm:inline">Order List</span>
          </Link>
        </div>
      </div>

      <div className="flex items-center space-x-4">
        {/* Notification */}
        <button className="relative text-gray-600 dark:text-gray-300">
          <Bell size={20} />
          <span className="absolute top-0 right-0 block h-2 w-2 rounded-full bg-red-500" />
        </button>

        {/* Dark Mode */}
        <button onClick={() => setDarkMode(!darkMode)} className="text-gray-600 dark:text-gray-300">
          {darkMode ? <Sun size={20} /> : <Moon size={20} />}
        </button>

        {/* Profile Dropdown */}
        <div className="relative" ref={dropdownRef}>
          <button
            onClick={() => setDropdownOpen(!dropdownOpen)}
            className="flex items-center space-x-2 text-sm text-gray-700 dark:text-white"
          >
            <img
              src="https://api.dicebear.com/7.x/initials/svg?seed=Snapyora"
              alt="avatar"
              className="w-8 h-8 rounded-full"
            />
            <ChevronDown size={16} />
          </button>

          {dropdownOpen && (
            <div className="absolute right-0 mt-2 w-40 bg-white dark:bg-gray-700 border dark:border-gray-600 rounded-md shadow-md z-50">
              <button
                onClick={() => {
                  localStorage.removeItem('ataservtoken');
                  window.location.href = '/login';
                }}
                className="block w-full text-left px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-600 text-sm text-gray-700 dark:text-white"
              >
                Logout
              </button>
            </div>
          )}
        </div>
      </div>
    </header>
  );
}
